angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.sellerUserDetailsController', ['$q', '$scope', 'platformWebApp.bladeNavigationService', 'virtoCommerce.marketplaceModule.webApi',
        function ($q, $scope, bladeNavigationService, marketplaceApi) {
            var blade = $scope.blade;
            blade.isLoading = false;

            function initializeBlade(data) {
                blade.currentEntity = !blade.isNew ? angular.copy(data) : { role: 'vcmp-agent-role' };
                blade.originalEntity = data;
                blade.command = {
                    sellerId: blade.sellerId,
                    sellerUserId: blade.currentEntity.id,
                    userDetails: blade.currentEntity
                };
                blade.isReadonly = blade.currentEntity.role === 'vcmp-owner-role';
                blade.isLoading = false;
            }

            blade.refresh = function (parentRefresh) {
                initializeBlade(blade.currentEntity);

                if (parentRefresh) {
                    blade.parentBlade.refresh(true);
                }
            };

            $scope.setForm = function (form) { $scope.formScope = form; };

            $scope.validateEmailAsync = function (value) {
                if (!blade.isNew) {
                    return $q.resolve();
                }

                return marketplaceApi.validateSellerUser({
                    sellerUser: { email: value }
                }).$promise.then(result => {
                    if (!_.any(result, error => error.propertyName === 'Email')) {
                        $scope.errorData = null;
                        return $q.resolve();
                    } else {
                        $scope.errorData = _.filter(result, error => error.propertyName === 'Email')[0];
                        return $q.reject();
                    }
                });
            };

            if (!blade.isNew) {
                blade.toolbarCommands = [
                    {
                        name: "platform.commands.save", icon: 'fas fa-save',
                        executeMethod: function() {
                            $scope.saveChanges();
                        },
                        canExecuteMethod: canSave
                    },
                    {
                        name: "platform.commands.reset", icon: 'fa fa-undo',
                        executeMethod: function () {
                            angular.copy(blade.originalEntity, blade.currentEntity);
                        },
                        canExecuteMethod: isDirty
                    },
                    {
                        name: "marketplace.commands.resend-invite", icon: 'fa fa-paper-plane',
                        executeMethod: function () {
                            $scope.sendInvite();
                        },
                        canExecuteMethod: function() { return true; }
                    }
                ];

                blade.onClose = function (closeCallback) {
                    bladeNavigationService.showConfirmationIfNeeded(isDirty(), canSave(), blade, $scope.saveChanges, closeCallback, "marketplace.dialogs.seller-user-save.title", "marketplace.dialogs.seller-user-save.message");
                };

                function isDirty() {
                    return !angular.equals(blade.currentEntity, blade.originalEntity);
                }

                function canSave() {
                    return isDirty() && $scope.formScope && $scope.formScope.$valid;
                }
            }

            $scope.saveChanges = function() {
                blade.isLoading = true;

                if (blade.isNew) {
                    blade.command.sendInvitation = true;
                    marketplaceApi.createSellerUser(blade.command, function () {
                        $scope.bladeClose();
                        blade.refresh(true);
                    });
                } else {
                    marketplaceApi.updateSellerUser(blade.command, function() {
                        blade.refresh(true);
                    });
                }
            }

            $scope.sendInvite = function () {
                blade.isLoading = true;
                marketplaceApi.sendSellerUserInvitation({
                    sellerId: blade.sellerId,
                    sellerUserId: blade.currentEntity.id
                }, function () {
                    blade.isLoading = false;
                });
            }

            blade.roles = [
                "vcmp-admin-role",
                "vcmp-agent-role"
            ];

            blade.refresh();
        }
    ]);
